import { toast } from "sonner";

// Client-side UX gate for CSV downloads.
// NOTE: This is a UX-level protection, not a server-side security boundary.
// Configurable via REACT_APP_CSV_PASSWORD env var (falls back to a default so
// existing deployments keep working). CRA/craco bundles REACT_APP_* into the
// build, so this remains a UX gate — not real cryptographic security.
const CSV_EXPORT_PASSWORD = process.env.REACT_APP_CSV_PASSWORD || "MiMa1618";
const CSV_SESSION_FLAG = "csvExportUnlocked";

/**
 * Prompt the user for the CSV export password once per session.
 * Returns true if the password matches (or if already unlocked in this tab),
 * false otherwise. On failure, shows a toast.
 */
export function ensureCsvPassword() {
  try {
    if (sessionStorage.getItem(CSV_SESSION_FLAG) === "1") return true;
  } catch (_) { /* sessionStorage may be unavailable */ }

  const pwd = window.prompt("Digite a senha para exportar dados em CSV:");
  if (pwd === null) return false; // user cancelled
  if (pwd !== CSV_EXPORT_PASSWORD) {
    toast.error("Senha incorreta. Exportação bloqueada.");
    return false;
  }
  try { sessionStorage.setItem(CSV_SESSION_FLAG, "1"); } catch (_) { /* ignore */ }
  toast.success("Senha aceita. Você pode exportar CSVs nesta sessão.");
  return true;
}
